import { CommonActionTypes } from "../../action-types";

const socCodes = JSON.parse(localStorage.getItem("socCodes"));

const initialState = {
  socCodes: socCodes ? socCodes : null,
};

export default function allSocCodesReducer(state = initialState, action) {
  switch (action.type) {
    case CommonActionTypes.GET_ALL_SOC_CODES_DATA:
      return {
        socCodes: action.payload,
      };
    default:
      return state;
  }
}
